import { memo } from "react";
import MultiSelectComponent from "ui-kit/src/MultipleSelect/MultiSelectComponent";
import { ButtonTabs, type ButtonTabsItem } from "ui-kit";
import { _ } from "i18n";
import ToggleSwitch from "ui-kit/src/ToggleSwitch/ToggleSwitch";
import { SelectValues } from "ui-kit/src/MultipleSelect/types";

interface FilterBarProps {
	clubs: ButtonTabsItem[];
	team: number | null;
	onTeamChange: (teamId: number) => void;
	selectedPlayer: SelectValues | null;
	onPlayerChange: (players: SelectValues | null) => void;
	playerListByTeam: any[];
	periodTabs: any[];
	periods: string[];
	onPeriodsChange: (periods: (string | number)[]) => void;
	showPlayerNumber: boolean;
	onShowPlayerNumberChange: () => void;
	isSticky?: boolean;
	isNarrow?: boolean;
	hideTeamSwitcher?: boolean;
}

const FilterBar = memo(
	({
		clubs,
		team,
		onTeamChange,
		selectedPlayer,
		onPlayerChange,
		playerListByTeam,
		periodTabs,
		periods,
		onPeriodsChange,
		showPlayerNumber,
		onShowPlayerNumberChange,
		isSticky = false,
		isNarrow = false,
		hideTeamSwitcher = false,
	}: FilterBarProps) => {
		return (
			<div className={`insight-page-container__filters${isSticky && !isNarrow ? " sticky-header" : ""}`}>
				<div className="insight-page-container__filters-selects">
					{hideTeamSwitcher === false && (
						<ButtonTabs items={clubs} active={team ? [team] : []} onChange={(value) => onTeamChange(value[0] as number)} />
					)}
					<MultiSelectComponent
						value={selectedPlayer}
						handleChange={onPlayerChange}
						items={playerListByTeam}
						placeholder={`${_("globalSearch.filter.content_type.players")}`}
						isCleareable={true}
					/>
					<div className="insight-page-container__filters-selects-period">
						<ButtonTabs items={periodTabs} active={periods} showCheck={true} onChange={onPeriodsChange} isMultiple={true} />
					</div>

					<div className="insight-page-container__filters-selects-switch">
						<ToggleSwitch
							selected={showPlayerNumber}
							handleChange={onShowPlayerNumberChange}
							rightOption={_("gamePage.dataInsights.label.playerNumber")}
						/>
					</div>
				</div>
			</div>
		);
	}
);

export default FilterBar;
